// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  TRIGGER: '[data-fragment="LangSwitch.trigger"]',
  ITEM: '[data-fragment="LangSwitch.item"]',
};

export default class LangSwitch extends WebComponent {
  constructor(props) {
    super(props);

    this.state = {
      windowOpened: false,
    };

    this.toggleWindow = this.toggleWindow.bind(this);
    this.closeWindow = this.closeWindow.bind(this);
  }

  didMount() {
    this.on('click', fragments.TRIGGER, this.toggleWindow);
    window.addEventListener('click', this.closeWindow);
  }

  toggleWindow = () => {
    const { windowOpened } = this.state;
    this.setState({
      windowOpened: !windowOpened,
    });
  };

  closeWindow = (e) => {
    if (!e.target.matches(fragments.ITEM) && !e.target.matches(fragments.TRIGGER)) {
      this.setState({
        windowOpened: false,
      });
    }
  };

  willUnMount() {}
  update() {
    const { windowOpened } = this.state;
    classNames(this.element, { 'lang-switch--window-opened': windowOpened });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/LangSwitch.js